import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RentalCarPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem('isMembership');
    navigate('/');
  }, [navigate]);
  return <></>;
};
export default RentalCarPage;
